var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeElapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Timer_01",
    "data-name": "Timer 01",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M11.5,23A11.5,11.5,0,1,1,23,11.5,11.514,11.514,0,0,1,11.5,23Zm0-21.69A10.19,10.19,0,1,0,21.69,11.5,10.2,10.2,0,0,0,11.5,1.31Z",
    fill: "#f1f1f2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M19.68,11.36H11.3V2.98A8.39,8.39,0,0,1,19.68,11.36Z",
    fill: "#f1f1f2"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M22.34,11.83H20.76a.33.33,0,1,1,0-.66h1.58a.33.33,0,0,1,0,.66Z",
    fill: "#f1f1f2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M2.23,11.83H.66a.33.33,0,1,1,0-.66H2.24a.33.33,0,1,1-.01.66Z",
    fill: "#f1f1f2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M11.3,22.67a.333.333,0,0,1-.33-.33V20.76a.33.33,0,1,1,.66,0v1.58A.333.333,0,0,1,11.3,22.67Z",
    fill: "#f1f1f2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M11.3,2.56a.333.333,0,0,1-.33-.33V.66a.33.33,0,1,1,.66,0V2.24A.324.324,0,0,1,11.3,2.56Z",
    fill: "#f1f1f2"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9863",
    "data-name": "Group 9863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M19.04,19.71a.3.3,0,0,1-.23-.1l-1.12-1.12a.32.32,0,0,1,0-.46.329.329,0,0,1,.46,0l1.12,1.12a.32.32,0,0,1,0,.46A.3.3,0,0,1,19.04,19.71Z",
    fill: "#f1f1f2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9864",
    "data-name": "Group 9864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M4.82,5.49a.3.3,0,0,1-.23-.1L3.47,4.28a.32.32,0,0,1,0-.46.329.329,0,0,1,.46,0L5.05,4.94a.32.32,0,0,1,0,.46A.334.334,0,0,1,4.82,5.49Z",
    fill: "#f1f1f2"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9865",
    "data-name": "Group 9865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M3.56,19.57a.3.3,0,0,1-.23-.1.32.32,0,0,1,0-.46l1.12-1.12a.325.325,0,0,1,.46.46L3.79,19.47A.345.345,0,0,1,3.56,19.57Z",
    fill: "#f1f1f2"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9866",
    "data-name": "Group 9866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M17.78,5.35a.3.3,0,0,1-.23-.1.32.32,0,0,1,0-.46l1.12-1.12a.325.325,0,0,1,.46.46L18.01,5.25A.3.3,0,0,1,17.78,5.35Z",
    fill: "#f1f1f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeElapsed);
export default __webpack_public_path__ + "static/media/time_elapsed.d1afb8069587ca3fca0fa42aabc79c3f.svg";
export { ForwardRef as ReactComponent };